<template>
  <div class="notification">
    {{message}}
  </div>
</template>

<script>
export default {
  props: {
    message: String,
  }
}
</script>
